<div class="health-check-container">
  <!-- Status Dashboard Header -->
  <div class="title-large" style="margin-bottom: 20px; padding-top: 40px">User Health Diagnostics</div>

  <div class="search-section">
    <div class="search-row">
      <div class="input-wrapper">
        <label for="email" class="input-label">User Email Address</label>
        <input id="email" type="email" [(ngModel)]="email" placeholder="Enter user e-mail to analyze"
               (keyup.enter)="onAnalyzeClicked()">
      </div>
      <button class="primary-button" (click)="onAnalyzeClicked()" [disabled]="isAnalyzing() || email === ''">
        @if (isAnalyzing()) {
          <div class="spinner"></div>
          Analyzing...
        } @else {
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
               stroke-linecap="round" stroke-linejoin="round">
            <circle cx="11" cy="11" r="8"/>
            <path d="m21 21-4.3-4.3"/>
          </svg>
          Run Analysis
        }
      </button>
    </div>
  </div>

  <!-- App Details Banner -->
  @if (contactId() || appDetails()) {
    <div class="user-summary-banner">
      @if (contactId()) {
        <div class="summary-item">
          <span class="summary-label">Contact ID:</span>
          <span class="summary-value">{{ contactId() }}</span>
        </div>
      }
      @if (appDetails(); as details) {
        <div class="summary-item">
          <span class="summary-label">OS:</span>
          <span class="summary-value">{{ details.os }}</span>
        </div>
        <div class="summary-item">
          <span class="summary-label">App Version:</span>
          <span class="summary-value">{{ details.version }}</span>
        </div>
        <div class="summary-item">
          <span class="summary-label">Last Used:</span>
          <span class="summary-value">{{ details.lastUsedDate | date:'medium' }}</span>
        </div>
      }
    </div>
  }

  <!-- Diagnostics Results Grid -->
  <div class="results-grid">

    <!-- Azure AD B2C Card -->
    <section class="status-card" [class]="'status-' + azureValidation()">
      <div class="card-header">
        <div class="status-icon-box">
          @if (azureValidation() === 'valid') {
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"
                 stroke-linecap="round" stroke-linejoin="round">
              <path d="M20 6 9 17l-5-5"/>
            </svg>
          } @else if (azureValidation() === 'invalid') {
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"
                 stroke-linecap="round" stroke-linejoin="round">
              <path d="m18 6-12 12"/>
              <path d="m6 6 12 12"/>
            </svg>
          } @else {
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"
                 stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="1"/>
            </svg>
          }
        </div>
        <h2 class="card-title">Azure AD B2C</h2>
      </div>

      <div class="check-list">
        <div class="check-item">
          @if (azureValidation() === 'default') {
            <ng-container *ngTemplateOutlet="defaultIcon"></ng-container>
          } @else if (azureUserExists()) {
            <ng-container *ngTemplateOutlet="validIcon"></ng-container>
          } @else {
            <ng-container *ngTemplateOutlet="invalidIcon"></ng-container>
          }
          <span class="check-label">User exists</span>
        </div>

        @for (user of authUsers(); track user.id) {
          <div class="auth-user-card">
            @if (user.companyCode === '102') {
              <div class="frigg-badge">Registered in Frigg</div>
            }

            <div class="user-info-row">
              <span class="user-label">ID</span>
              <span class="user-value">{{ user.id }}</span>
            </div>

            <div class="user-info-row">
              <span class="user-label">Status</span>
              <span class="user-value" [style.color]="user.accountEnabled ? '#166534' : '#991b1b'">
                {{ user.accountEnabled ? 'Enabled' : 'Disabled' }}
              </span>
            </div>

            <div class="user-info-row">
              <span class="user-label">Company Code</span>
              <span class="user-value">{{ user.companyCode }}</span>
            </div>

            <div class="user-info-row">
              <span class="user-label">Name</span>
              <span class="user-value">{{ user.givenName }} {{ user.surname }}</span>
            </div>

            <div class="user-info-row">
              <span class="user-label">Created</span>
              <span class="user-value">{{ user.createdDateTime | date:'shortDate' }}</span>
            </div>
          </div>
        }
      </div>
    </section>

    <!-- Dynamics - Freya Card -->
    <section class="status-card" [class]="'status-' + dynamicsValidation()">
      <div class="card-header">
        <div class="status-icon-box">
          @if (dynamicsValidation() === 'valid') {
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"
                 stroke-linecap="round" stroke-linejoin="round">
              <path d="M20 6 9 17l-5-5"/>
            </svg>
          } @else if (dynamicsValidation() === 'invalid') {
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"
                 stroke-linecap="round" stroke-linejoin="round">
              <path d="m18 6-12 12"/>
              <path d="m6 6 12 12"/>
            </svg>
          } @else {
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"
                 stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="1"/>
            </svg>
          }
        </div>
        <h2 class="card-title">Dynamics - Freya</h2>
      </div>

      <div class="check-list">
        <div class="check-item">
          @if (dynamicsValidation() === 'default') {
            <ng-container *ngTemplateOutlet="defaultIcon"></ng-container>
          } @else if (virtualKeyValidation()) {
            <ng-container *ngTemplateOutlet="validIcon"></ng-container>
          } @else {
            <ng-container *ngTemplateOutlet="invalidIcon"></ng-container>
          }
          <span class="check-label">Virtual key</span>
        </div>

        <div class="check-item">
          @if (dynamicsValidation() === 'default') {
            <ng-container *ngTemplateOutlet="defaultIcon"></ng-container>
          } @else if (rfidDriivzIdValidation()) {
            <ng-container *ngTemplateOutlet="validIcon"></ng-container>
          } @else {
            <ng-container *ngTemplateOutlet="invalidIcon"></ng-container>
          }
          <span class="check-label">RFID has Driivz ID ({{ rfidDriivzIdCounts() }})</span>
        </div>

        <div class="check-item">
          @if (dynamicsValidation() === 'default') {
            <ng-container *ngTemplateOutlet="defaultIcon"></ng-container>
          } @else if (countryValidation()) {
            <ng-container *ngTemplateOutlet="validIcon"></ng-container>
          } @else {
            <ng-container *ngTemplateOutlet="invalidIcon"></ng-container>
          }
          <span class="check-label">Country</span>
        </div>

        <div class="check-item">
          @if (dynamicsValidation() === 'default') {
            <ng-container *ngTemplateOutlet="defaultIcon"></ng-container>
          } @else if (statusValidation()) {
            <ng-container *ngTemplateOutlet="validIcon"></ng-container>
          } @else {
            <ng-container *ngTemplateOutlet="invalidIcon"></ng-container>
          }
          <span class="check-label">Status marked as "Active"</span>
        </div>

        <div class="check-item">
          @if (dynamicsValidation() === 'default') {
            <ng-container *ngTemplateOutlet="defaultIcon"></ng-container>
          } @else if (rolesValidation()) {
            <ng-container *ngTemplateOutlet="validIcon"></ng-container>
          } @else {
            <ng-container *ngTemplateOutlet="invalidIcon"></ng-container>
          }
          <span class="check-label">Roles</span>
        </div>

        <div class="check-item">
          @if (dynamicsValidation() === 'default') {
            <ng-container *ngTemplateOutlet="defaultIcon"></ng-container>
          } @else if (driverContractDriivzIdValidation()) {
            <ng-container *ngTemplateOutlet="validIcon"></ng-container>
          } @else {
            <ng-container *ngTemplateOutlet="invalidIcon"></ng-container>
          }
          <span class="check-label">Driver contract has Driivz ID</span>
        </div>

        <div class="check-item">
          @if (dynamicsValidation() === 'default') {
            <ng-container *ngTemplateOutlet="defaultIcon"></ng-container>
          } @else if (subcontractDriivzIdValidation()) {
            <ng-container *ngTemplateOutlet="validIcon"></ng-container>
          } @else {
            <ng-container *ngTemplateOutlet="invalidIcon"></ng-container>
          }
          <span class="check-label">Driivz ID exists for subcontracts ({{ subcontractDriivzIdCounts() }})</span>
        </div>
      </div>
    </section>


    <!-- Send Grid Card -->
    <section class="status-card" [class]="'status-' + sendGridValidation()">
      <div class="card-header">
        <div class="status-icon-box">
          @if (sendGridValidation() === 'valid') {
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"
                 stroke-linecap="round" stroke-linejoin="round">
              <path d="M20 6 9 17l-5-5"/>
            </svg>
          } @else if (sendGridValidation() === 'invalid') {
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"
                 stroke-linecap="round" stroke-linejoin="round">
              <path d="m18 6-12 12"/>
              <path d="m6 6 12 12"/>
            </svg>
          } @else {
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"
                 stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="1"/>
            </svg>
          }
        </div>
        <h2 class="card-title">Send Grid</h2>
      </div>

      <div class="check-list">
        <div class="check-item">
          @if (sendGridValidation() === 'default') {
            <ng-container *ngTemplateOutlet="defaultIcon"></ng-container>
          } @else if (!sendGridEmailMarkedAsSpam()) {
            <ng-container *ngTemplateOutlet="validIcon"></ng-container>
          } @else {
            <ng-container *ngTemplateOutlet="invalidIcon"></ng-container>
          }
          <span class="check-label">Email Reputation</span>
        </div>

        @if (sendGridEmailMarkedAsSpam()) {
          <div class="spam-action">
            <div class="frigg-badge"
                 style="background: #fff7ed; color: #9a3412; border-color: #ffedd5; margin-bottom: 12px">
              Email marked as spam
            </div>
            <button class="remove-spam-btn" (click)="removeEmailFromSpam()">
              Remove from Spam Reports
            </button>
          </div>
        }
      </div>
    </section>

  </div>
</div>

<!-- Reusable Templates -->
<ng-template #validIcon>
  <div class="status-icon-box status-valid" style="width: 20px; height: 20px;">
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="4"
         stroke-linecap="round" stroke-linejoin="round">
      <path d="M20 6 9 17l-5-5"/>
    </svg>
  </div>
</ng-template>

<ng-template #invalidIcon>
  <div class="status-icon-box status-invalid" style="width: 20px; height: 20px;">
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="4"
         stroke-linecap="round" stroke-linejoin="round">
      <path d="m18 6-12 12"/>
      <path d="m6 6 12 12"/>
    </svg>
  </div>
</ng-template>

<ng-template #defaultIcon>
  <div class="status-icon-box status-default" style="width: 20px; height: 20px; opacity: 0.3">
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="4"
         stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="1"/>
    </svg>
  </div>
</ng-template>
